import { makeMentionsSelector } from "../../redux/selectors/mentions";
import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { recallNumber } from "../../utils/Number";
import { isNullOrNaN, isValueInChoiceList } from "../../utils";

const minValueKey = "MinValue";
const errorKey = "LowerBoundNotFulfilled";

export function minValue(question, variable) {
    const { name: variableName } = variable;
    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const { settings } = question;
        const { interview } = getState();
        let min = recallNumber(settings[minValueKey], interview);
        if (isNullOrNaN(min)) min = Number.MIN_SAFE_INTEGER;

        const mentions = mentionsSelector(getState());
        if (mentions.length) {
            const mentionValue = mentions[0].value;
            const num = recallNumber(mentionValue, interview);
            const isValid = isValueInChoiceList(mentionValue, variable) || num >= min;
            if (!isValid) {
                return { variableName, error: { key: errorKey, args: { min: String(min) } } };
            }
        }
        return null;
    };
}
